import { Button, CloseButton, Dialog, Image, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";

import FormReferido from "./FormReferido";
import ModalStatus from "./ModalStatus";

const ModalForm = ({ name, type, optionsDevelops }) => {
    const [status, setStatus] = useState("error");
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenStatus, setIsOpenStatus] = useState(false);

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);
    const onOpenStatus = () => setIsOpenStatus(true);
    const onCloseStatus = () => setIsOpenStatus(false);

    return (
        <>
            <Button
                onClick={onOpen}
                px={16}
                height="43px"
                borderRadius="md"
                fontWeight="normal"
                color="#002B49"
                bg="white"
                size="lg"
            >
                {name}
            </Button>
            <Dialog.Root
                open={isOpen}
                onOpenChange={() => onClose()}
                size="xl"
                preventScroll
                placement="center"
            >
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content pl={6} pr={6} top={{ base: "200px", md: "0px" }}>
                        <Dialog.Header />
                        <Dialog.CloseTrigger asChild>
                            <CloseButton
                                bg="#D8D8D8"
                                color="#5F5F5F"
                                rounded="full"
                                top={{ base: -1, md: -3 }}
                                right={{ base: -1, md: -4 }}
                                p={2}
                            />
                        </Dialog.CloseTrigger>
                        <Dialog.Body color="black" pt={6} pb={6} px={4}>
                            <Stack alignItems="center">
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/logos/logo-guia.webp"
                                    w="100px"
                                    alt="simple icon"
                                />
                            </Stack>
                            <Stack my={6} alignItems="center" textAlign="center">
                                <Text fontWeight={700} fontSize="md">
                                    {type}
                                </Text>
                            </Stack>
                            <FormReferido
                                onClose={onClose}
                                onOpen={onOpenStatus}
                                setTitle={setTitle}
                                setMessage={setMessage}
                                setStatus={setStatus}
                                optionsDevelops={optionsDevelops}
                            />
                        </Dialog.Body>
                        <Dialog.Footer></Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Root>
            <ModalStatus
                isOpen={isOpenStatus}
                onClose={onCloseStatus}
                type={status}
                title={title}
                message={message}
            />
        </>
    );
};

export default ModalForm;
